const translations = {
  title: "Global Platform",
  tools: {
    datasets: "Datasets",
    objectTypeMerge: "Merge Object Types",
    lidarClearance: "Lidar Clearance",
    lidarUploadStatus: "LiDAR Upload Dashboard",
  },
};

export default translations;
